import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTZ: CultureInfo = {
  name: 'en-TZ',
  displayName: 'English (Tanzania)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TZ',
  parent: CultureInfoEn
};
